var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"label":"Suchen","outlined":"","placeholder":"Namen eingeben","prepend-inner-icon":"mdi-magnify"},model:{value:(_vm.searchInput),callback:function ($$v) {_vm.searchInput=$$v},expression:"searchInput"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }